var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.length > 0)?_c('div',{staticClass:"c-table"},[_c('edit-table',{attrs:{"option":_vm.tableOption,"loading":_vm.loading,"data":_vm.data}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }